import Head from "@app/components/Head";
import VideosList from "@app/components/Videos";
import { getSubmissionStatus } from "src/helpers/submissionStatus";

function Videotheque() {
  return (
    <>
      <Head options={{ title: "Vidéothèque" }} />
      <section>
        <div className="container">
          <h1 className="text-4xl md:text-5xl">Vidéothèque</h1>
          <p className="italic text-gray-700">Vivez le CJD Business Awards</p>
          <div className="grid lg:grid-cols-2 lg:gap-8 py-12">
            <VideosList />
          </div>
        </div>
      </section>
    </>
  );
}

export async function getServerSideProps() {
  return {
    props: {
      submissionStatus: await getSubmissionStatus(),
    },
  };
}

export default Videotheque;
